function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
import React, { forwardRef } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var SvgZoomIn = /*#__PURE__*/forwardRef(function (props, svgRef) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), ___EmotionJSX("path", {
    fill: "currentColor",
    d: "M9.414 3a6.414 6.414 0 015.18 10.198l6.407 6.408-1.395 1.395-6.408-6.407A6.414 6.414 0 119.414 3zm0 1.973a4.44 4.44 0 100 8.88 4.44 4.44 0 000-8.88zM10.25 7v1.75H12v1.5h-1.75V12h-1.5v-1.751L7 10.25v-1.5l1.75-.001V7h1.5z"
  }));
});
export default SvgZoomIn;